module.exports = "\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.content-in .row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.Blue{\r\n    color:blue;    \r\n}\r\n\r\n.Green{\r\n    color:brown\r\n}\r\n\r\n.Red{\r\n    color:red;\r\n}\r\n\r\n.DGreen{\r\n    color: green\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/depart-enquiry/scn-authorization/scn-authorization/scn-authorization.component.css
// module id = ./src/app/hrms/depart-enquiry/scn-authorization/scn-authorization/scn-authorization.component.css
// module chunks = main